import axios from "axios";

export default {
  deleteBaseField(id) {
    return axios.delete(`/banner/base-fields/${id}`);
  }
}